import { render, staticRenderFns } from "./BookRoom.vue?vue&type=template&id=23613e0e&scoped=true&"
import script from "./BookRoom.vue?vue&type=script&lang=js&"
export * from "./BookRoom.vue?vue&type=script&lang=js&"
import style0 from "./BookRoom.vue?vue&type=style&index=0&id=23613e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23613e0e",
  null
  
)

export default component.exports